import $api from "@/frontend/shared/api/axios";

export async function postCreatePortfolioCompany(id: number) {
  const response = await $api.post("/portfolio-companies", { companies: [{ companyId: id }] });
  return response;
}
